import $ from 'jquery';
import {TweenMax, Power2} from 'gsap/TweenMax';

import Device from '../helpers/Device';

class PcHeaderAnimator {
  constructor() {
    this.ANIAMTION_DURATION_SECOND = 0.3;
    this.DEFAULT_POS_Y = -80;

    this.$header = $('#js-fix-header');
    this.$fixThreshold = $('#js-fix-header-threshold');

    this.fixThresholdY = -1;
    this.isFixed = false;

    if (this.$header.length > 0) {
      this.init();
      this.addEvent();
    }
  }

  init() {
    this.fixThresholdY = this.$fixThreshold.offset().top;

    if (this.isOverThreshold()) {
      this.isFixed = true;
      this.$header.css({top: 0});

      if (Device.isPc()) {
        this.$header.show();
      }
    }
  }

  addEvent() {
    $(window).on('scroll', () => {
      if (this.isFixed && !this.isOverThreshold()) {
        // 固定済みかつ、スクロールしきい値を下回った時.
        this.doScrollUp();
      } else if (!this.isFixed && this.isOverThreshold()) {
        // 固定済みでなく、スクロールしきい値を上回った時.
        this.doScrollDown();
      }
    });

    $(window).on('resize', () => {
      if (Device.isPc() && this.isFixed) {
        // 画面幅がPCサイズで、固定済みの時、ヘッダーを表示.
        this.$header.show();
      } else if (Device.isMobile()) {
        // 画面幅がSPの時、ヘッダーを非表示に.
        this.$header.hide();
      }
    });
  }

  isOverThreshold() {
    return $(window).scrollTop() > this.fixThresholdY;
  }

  doScrollDown() {
    this.isFixed = true;

    TweenMax.to(this.$header.get(0), this.ANIAMTION_DURATION_SECOND, {
      top: 0,
      ease: Power2.easeOut,
      onStart: () => {
        // 画面幅がSPの時に、hideが打ち消されないように.
        if (Device.isPc()) {
          this.$header.show();
        }
      },
    });
  };

  doScrollUp() {
    this.isFixed = false;

    TweenMax.to(this.$header.get(0), this.ANIAMTION_DURATION_SECOND / 2, {
      top: `${this.DEFAULT_POS_Y}px`,
      ease: Power2.easeOut,
      onComplete: () => {
        this.$header.hide();
      },
    });
  }
}

export default PcHeaderAnimator;